// extracted by css-extract-rspack-plugin
export default {"embed":"src-pages-manage-Wrangler-module__embed-f76jcc"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"embed\":\"src-pages-manage-Wrangler-module__embed-f76jcc\"}";
        // 1793732227514
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  